import { render, staticRenderFns } from "./ModalLogout.vue?vue&type=template&id=aafbf606&scoped=true&"
import script from "./ModalLogout.vue?vue&type=script&lang=ts&"
export * from "./ModalLogout.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLogout.vue?vue&type=style&index=0&id=aafbf606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafbf606",
  null
  
)

export default component.exports